/* Copyright Verge Technologies 2018
 * @file favouriteItem.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component for displaying a favourite item
 * panel on a product
 */

import React from 'react';
import PropTypes from 'prop-types';

const noImage = require('../../img/no-image.jpg');

const selectLoop = (quantity) => {
  const selectsObj = [];
  for (let i = 1; i <= 100; i++) {
    selectsObj.push(<option value={i} key={i}>{i}</option>);
  }
  return selectsObj;
};

const FavouriteItem = (props) => {
  return (
    <li>
      <div className="cols cols-img">        
        {props.item.image_urls.length > 0 && 
        <img src={props.item.image_urls[0]} alt="favourite" />}
        {props.item.image_urls.length === 0 && 
        <img src={noImage} alt="product" />}
      </div>
      <div className="cols cols-desc">
        <div className="name">{props.item.name}</div>
        <div className="stock">
          In Stock <span>CPT|JHB</span>
        </div>
      </div>
      <div className="cols cols-qty">
        <select name="qty" value={props.item.quantity} onChange={e => props.quantityUpdate(props.item.hash_id, e)}>
          {selectLoop(props.item.quantity).map((option) => {
            return option;
          })}
        </select>
      </div>
      <div className="cols cols-action">
        <a className="icon" onClick={e => props.removeItem(props.item.hash_id)}>
          <svg width="13px" height="13px" viewBox="0 0 13 13">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g transform="translate(-6.000000, -5.000000)" fill="#FFFFFF" fillRule="nonzero">
                <path
                  d="M12.2804289,19.2680847 C12.0417341,19.2680847 11.8128156,19.1732636 11.6440328,19.0044808 C11.4752501,18.8356981 11.3804289,18.6067796 11.3804289,18.3680847 L11.3804289,12.1920847 L5.20342893,12.1920847 C4.96473409,12.1920847 4.73581557,12.0972636 4.56703283,11.9284808 C4.39825009,11.7596981 4.30342893,11.5307796 4.30342893,11.2920847 C4.30342893,10.7950285 4.70637266,10.3920847 5.20342893,10.3920847 L11.3804289,10.3920847 L11.3804289,4.21508473 C11.3804289,3.71802845 11.7833727,3.31508473 12.2804289,3.31508473 C12.7774852,3.31508473 13.1804289,3.71802845 13.1804289,4.21508473 L13.1804289,10.3920847 L19.3574289,10.3920847 C19.8561421,10.3920847 20.2604289,10.7963716 20.2604289,11.2950847 C20.2604289,11.7937979 19.8561421,12.1980847 19.3574289,12.1980847 L13.1814289,12.1980847 L13.1814289,18.3740847 C13.1814289,18.6127796 13.0866078,18.8416981 12.917825,19.0104808 C12.7490423,19.1792636 12.5201238,19.2740847 12.2814289,19.2740847 L12.2804289,19.2680847 Z"
                  id="Union_4614"
                  transform="translate(12.281929, 11.294585) rotate(45.000000) translate(-12.281929, -11.294585) "
                />
              </g>
            </g>
          </svg>
        </a>
      </div>
    </li>
  );
};

FavouriteItem.propTypes = {
  item: PropTypes.shape({
    hash_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.string.isRequired,
    image_urls: PropTypes.shape.isRequired,
  }).isRequired,
};

export default FavouriteItem;



// WEBPACK FOOTER //
// ./src/components/FavouriteItem/favouriteItem.js